import { atom, useAtom } from "jotai";
import { useEffect } from "react";

// Images des pages
const pictures = [
  "IMG20250106-061123-39", "image9", "IMG20250106-060534-27", "image1",
  "IMG20250106-060559-28", "image3", "IMG20250106-060450-26", "image13",
  "IMG20250106-060740-29", "image15", "IMG20250106-060806-30", "IMG20250107-012955-46",
  "IMG20250106-061007-36","IMG20250113-004634-68","IMG20250113-005556-75","IMG20250113-011115-78",
  "IMG20250113-021405-83","IMG20250113-011142-81","IMG20250113-023429-89","IMG20250113-004658-69"
];

// Atom pour la page courante
export const pageAtom = atom(0);

// Pages du livre
export const pages = [
  { front: "book-cover", back: pictures[0] },
];

for (let i = 1; i < pictures.length - 1; i += 2) {
  pages.push({
    front: pictures[i % pictures.length],
    back: pictures[(i + 1) % pictures.length],
  });
}

pages.push({ front: pictures[pictures.length - 1], back: "book-back" });

// Composant UI
export const UI = () => {
  const [page, setPage] = useAtom(pageAtom);

  // Son de flip
  useEffect(() => {
    const audio = new Audio("/audios/page-flip-01a.mp3");
    audio.play();
  }, [page]);

  return (
    <>
      {/* Navigation principale */}
      <main className="pointer-events-none select-none z-10 fixed inset-0 flex justify-between flex-col">
        <a
          className="pointer-events-auto mt-10 ml-10"
          href="https://lessons.wawasensei.dev/courses/react-three-fiber"
        >
          <img className="w-20" src="/images/wawasensei-white.png" />
        </a>

        <div className="w-full overflow-auto pointer-events-auto flex justify-center">
          <div className="overflow-auto flex items-center gap-4 max-w-full p-10">
            {[...pages].map((_, index) => (
              <button
                key={index}
                className={`border-transparent hover:border-white transition-all duration-300 px-4 py-3 rounded-full text-lg uppercase shrink-0 border ${
                  index === page ? "bg-white/90 text-black" : "bg-black/30 text-white"
                }`}
                onClick={() => setPage(index)}
              >
                {index === 0 ? "Cover" : `Page ${index}`}
              </button>
            ))}

            <button
              className={`border-transparent hover:border-white transition-all duration-300 px-4 py-3 rounded-full text-lg uppercase shrink-0 border ${
                page === pages.length ? "bg-white/90 text-black" : "bg-black/30 text-white"
              }`}
              onClick={() => setPage(pages.length)}
            >
              Back Cover
            </button>
          </div>
        </div>
      </main>

      {/* Animation horizontale des titres */}
      <div className="fixed inset-0 flex items-center -rotate-2 select-none">
        <div className="relative">
          <div className="bg-white/0 animate-horizontal-scroll flex items-center gap-8 w-max px-8">
            <h1 className="shrink-0 text-white text-10xl font-black">Wawa Sensei</h1>
            <h2 className="shrink-0 text-white text-8xl italic font-light">React Three Fiber</h2>
            <h2 className="shrink-0 text-white text-12xl font-bold">Three.js</h2>
            <h2 className="shrink-0 text-transparent text-12xl font-bold italic outline-text">Ultimate Guide</h2>
            <h2 className="shrink-0 text-white text-9xl font-medium">Tutorials</h2>
            <h2 className="shrink-0 text-white text-9xl font-extralight italic">Learn</h2>
            <h2 className="shrink-0 text-white text-13xl font-bold">Practice</h2>
            <h2 className="shrink-0 text-transparent text-13xl font-bold outline-text italic">Creative</h2>
          </div>

          <div className="absolute top-0 left-0 bg-white/0 animate-horizontal-scroll-2 flex items-center gap-8 px-8 w-max">
            <h1 className="shrink-0 text-white text-10xl font-black">Wawa Sensei</h1>
            <h2 className="shrink-0 text-white text-8xl italic font-light">React Three Fiber</h2>
            <h2 className="shrink-0 text-white text-12xl font-bold">Three.js</h2>
            <h2 className="shrink-0 text-transparent text-12xl font-bold italic outline-text">Ultimate Guide</h2>
            <h2 className="shrink-0 text-white text-9xl font-medium">Tutorials</h2>
            <h2 className="shrink-0 text-white text-9xl font-extralight italic">Learn</h2>
            <h2 className="shrink-0 text-white text-13xl font-bold">Practice</h2>
            <h2 className="shrink-0 text-transparent text-13xl font-bold outline-text italic">Creative</h2>
          </div>
        </div>
      </div>
    </>
  );
};
